/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCDownIcon20Solid = forwardRef('ArrowCDownIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M17.222 6.403a1.375 1.375 0 0 1 0 1.944l-5.013 5.013a3.125 3.125 0 0 1-4.42 0L2.778 8.347a1.375 1.375 0 1 1 1.945-1.944l5.012 5.012a.375.375 0 0 0 .53 0l5.014-5.012a1.375 1.375 0 0 1 1.944 0Z" })));
});
